import LegalLayout from "components/LegalLayout"

const TermsPage = () => (
  <LegalLayout title="Terms of Use" lastUpdated="June 8, 2026" path="/terms">
    <h2>1. Introduction</h2>
    <p>
      This website (the &ldquo;Site&rdquo;) is operated by r4v3n LLC (&ldquo;r4v3n,&rdquo;
      &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;). The Site showcases the generative,
      print, and photographic artwork of the artist known as r4v3n, presents information about his
      collections, and links to third-party marketplaces where works may be viewed or acquired. By
      accessing or using the Site, you agree to these Terms of Use.
    </p>

    <h2>2. Acceptance of terms</h2>
    <p>
      These Terms of Use constitute a binding agreement between you and r4v3n LLC. If you do not
      agree with any part of these terms, you should not use the Site. We may update these terms
      from time to time as described in Section 9; your continued use of the Site after changes are
      posted constitutes acceptance of the revised terms.
    </p>

    <h2>3. Intellectual property</h2>
    <p>
      All artwork, images, text, design, code, and other content displayed on the Site are the
      property of r4v3n LLC or its licensors and are protected by copyright and other intellectual
      property laws. <strong>r4v3n LLC retains all copyright in the artworks displayed.</strong>
    </p>
    <p>
      Viewing, browsing, or otherwise accessing the Site does not transfer any intellectual property
      rights to you. Owning a non-fungible token (NFT) associated with a work confers blockchain
      title to that token, but it does not transfer copyright or any other intellectual property
      rights in the underlying artwork unless expressly stated by the specific terms of the
      collection or platform through which the work was released. Each collection&rsquo;s license
      (for example, the license noted on its Art Blocks, SuperRare, Bright Moments, Plottables, or
      Verse page) governs the rights conveyed with that work.
    </p>

    <h2>4. Acceptable use</h2>
    <p>You agree that you will not:</p>
    <ul>
      <li>scrape, crawl, harvest, or systematically extract content or data from the Site;</li>
      <li>reproduce, resell, or distribute images from the Site as your own work;</li>
      <li>create derivative works for commercial purposes without prior written permission;</li>
      <li>use the Site or its content to train machine-learning or generative-AI models;</li>
      <li>misrepresent your affiliation with r4v3n or r4v3n LLC; or</li>
      <li>use the Site in any way that violates applicable law or infringes the rights of others.</li>
    </ul>

    <h2>5. Third-party platforms</h2>
    <p>
      The Site links to third-party platforms and marketplaces, including but not limited to Art
      Blocks, SuperRare, Bright Moments, Plottables, and Verse. Those platforms are operated by
      independent third parties and are governed by their own terms of service and privacy policies.
      We do not control and are not responsible for the content, availability, terms, or conduct of
      any third-party platform. Transactions you enter into on those platforms are solely between you
      and the platform or counterparty.
    </p>

    <h2>6. Disclaimers</h2>
    <p>
      The Site and all content are provided &ldquo;as is&rdquo; and &ldquo;as available,&rdquo;
      without warranties of any kind, whether express or implied, including but not limited to
      warranties of merchantability, fitness for a particular purpose, accuracy, or
      non-infringement. We do not warrant that the Site will be uninterrupted, error-free, or secure.
      Information on the Site is provided for general informational purposes only and does not
      constitute financial, investment, legal, or tax advice. Digital assets and NFTs are highly
      volatile and speculative; their value may fluctuate or fall to zero, and blockchain
      transactions are generally irreversible.
    </p>

    <h2>7. Limitation of liability</h2>
    <p>
      To the fullest extent permitted by law, r4v3n LLC and its members, officers, and affiliates
      will not be liable for any indirect, incidental, special, consequential, or punitive damages,
      or for any loss of profits, data, goodwill, or digital assets, arising out of or related to
      your use of (or inability to use) the Site, whether based in contract, tort, or otherwise. In
      no event will our total liability for all claims related to the Site exceed one hundred U.S.
      dollars (US $100).
    </p>

    <h2>8. Governing law</h2>
    <p>
      These Terms of Use are governed by the laws of the State of Delaware, without regard to its
      conflict-of-laws principles. You agree that any dispute arising out of or relating to these
      terms or the Site will be subject to the exclusive jurisdiction of the state and federal courts
      located in Delaware.
    </p>

    <h2>9. Changes to these terms</h2>
    <p>
      We may revise these Terms of Use at any time by posting an updated version on this page with a
      new &ldquo;Last updated&rdquo; date. Material changes will be effective when posted. We
      encourage you to review these terms periodically.
    </p>

    <h2>10. Contact</h2>
    <p>
      Questions about these Terms of Use may be directed to r4v3n LLC at{" "}
      <a href="mailto:support@r4v3n.art">support@r4v3n.art</a>.
    </p>
  </LegalLayout>
)

export default TermsPage
